import { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { Textarea } from '../ui/textarea';

interface MarkdownEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  minHeight?: number;
}

export function MarkdownEditor({
  value,
  onChange,
  placeholder,
  disabled,
  className,
  minHeight = 160
}: MarkdownEditorProps) {
  const [activeTab, setActiveTab] = useState<'edit' | 'preview'>('edit');

  return (
    <div className={className}>
      <Tabs value={activeTab} onValueChange={(tab) => setActiveTab(tab as 'edit' | 'preview')} className="space-y-2">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="edit">Edit</TabsTrigger>
          <TabsTrigger value="preview">Preview</TabsTrigger>
        </TabsList>
        <TabsContent value="edit">
          <Textarea
            value={value}
            onChange={(event) => onChange(event.target.value)}
            placeholder={placeholder}
            disabled={disabled}
            style={{ minHeight }}
            className="resize-y"
          />
        </TabsContent>
        <TabsContent value="preview">
          <div
            className="border rounded-md bg-white p-4 text-sm text-gray-800 whitespace-pre-wrap"
            style={{ minHeight }}
          >
            {value ? (
              <ReactMarkdown>{value}</ReactMarkdown>
            ) : (
              <span className="text-gray-400">Nothing to preview.</span>
            )}
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
